import { useState } from 'react';
import { ChevronDown, BarChart3, Users, FolderOpen, TrendingUp, Package, FileText, PieChart, Settings, ShieldCheck, BookOpen, ShieldAlert, Truck, Calendar, MessageSquare, Wrench, ClipboardList, DollarSign, Map } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const menuItems = [
  {
    section: 'GŁÓWNE',
    items: [
      { label: 'Dashboard', href: '/admin-dashboard', icon: BarChart3 },
      { label: 'Dashboard Menadżera', href: '/admin-manager-dashboard', icon: BarChart3 },
      { label: 'Analytics', href: '/admin-analytics', icon: PieChart },
      { label: 'Analytics Dashboard PRO', href: '/admin-analytics-dashboard', icon: TrendingUp },
      { label: 'Segmentacja Użytkowników', href: '/admin-analytics-segmentation', icon: Users },
      { label: 'Chat wewnętrzny', href: '/admin-chat', icon: MessageSquare },
    ]
  },
  {
    section: 'SPRZEDAŻ & CRM',
    items: [
      { label: 'Pulpit Handlowca', href: '/salesman-dashboard', icon: BarChart3 },
      { label: 'CRM Leady', href: '/admin-crm', icon: Users },
      { label: 'Agent Sprzedaży AI', href: '/admin-sales-agent', icon: MessageSquare },
      { label: 'Kreator Ofert', href: '/admin-offer-creator', icon: FileText },
      { label: 'Kontrakty', href: '/admin-contracts', icon: ClipboardList },
      { label: 'Zamówienia / Projekty', href: '/admin-orders', icon: FolderOpen },
      { label: 'Kalkulator Wycen', href: '/admin-quote-creator', icon: TrendingUp },
    ]
  },
  {
    section: 'PRODUKCJA',
    items: [
      { label: 'Planowanie Produkcji', href: '/admin-production-plan', icon: Settings },
      { label: 'Fabryki', href: '/admin-factories', icon: Package },
      { label: 'Kontrola Jakości', href: '/admin-qc', icon: ShieldCheck },
      { label: 'Kalendarz Montażu', href: '/admin-assembly-calendar', icon: Calendar },
      { label: 'Kalendarz Ofert', href: '/admin-schedule-calendar', icon: Calendar },
      { label: 'Wysyłki', href: '/admin-shipments', icon: Truck },
    ]
  },
  {
    section: 'DOKUMENTACJA & PLM',
    items: [
      { label: 'Cykl Życia Produktu', href: '/admin-plm', icon: Map },
      { label: 'Katalog Dokumentów', href: '/admin-docs-catalog', icon: BookOpen },
      { label: 'Reklamacje & Serwis', href: '/admin-claims', icon: ShieldAlert },
    ]
  },
  {
    section: 'FINANSE',
    items: [
      { label: 'Faktury', href: '/admin-invoices', icon: FileText },
      { label: 'Portal Księgowy', href: '/admin-accounting', icon: DollarSign },
      { label: 'Rozliczenia Fabryk', href: '/admin-factory-invoices', icon: BarChart3 },
      { label: 'Rozliczenia Klientów', href: '/admin-client-invoices', icon: BarChart3 },
    ]
  },
  {
    section: 'KATALOG PRODUKTÓW',
    items: [
      { label: 'Cennik Saun', href: '/admin-sauna-pricing', icon: TrendingUp },
      { label: 'Dashboard Marż', href: '/admin-margin-dashboard', icon: TrendingUp },
      { label: 'Dashboard Zysków', href: '/admin-profit-dashboard', icon: BarChart3 },
    ]
  },
  {
    section: 'KONFIGURACJE',
    items: [
      { label: 'Konfigurator', href: '/admin-configurator', icon: Wrench },
    ]
  },
];

export default function AdminSidebar() {
  const [expandedSections, setExpandedSections] = useState(
    Object.fromEntries(menuItems.map(s => [s.section, true]))
  );
  const location = useLocation();
  const isActive = (href) => location.pathname === href;

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <div className="w-64 bg-white border-r border-gray-200 h-screen overflow-y-auto flex flex-col sticky top-0 scrollbar-hide">
      <div className="p-6 border-b border-gray-200">
        <h2 className="font-inter text-base font-semibold text-gray-900">LYKKE Admin</h2>
      </div>

      <nav className="flex-1 overflow-y-auto py-4 px-0 space-y-2">
        {menuItems.map((section) => (
          <div key={section.section}>
            <button
              onClick={() => toggleSection(section.section)}
              className="w-full flex items-center justify-between px-6 py-2 text-xs uppercase tracking-wider font-inter font-semibold text-gray-400 hover:text-gray-600 transition-colors"
            >
              {section.section}
              <ChevronDown size={13} className={`transition-transform ${expandedSections[section.section] ? 'rotate-180' : ''}`} />
            </button>

            {expandedSections[section.section] && (
              <div className="mt-1 mb-2">
                {section.items.map((item) => {
                  const Icon = item.icon;
                  const active = isActive(item.href);
                  return (
                    <Link
                      key={item.href}
                      to={item.href}
                      className={`flex items-center gap-3 px-6 py-2.5 text-sm font-inter transition-colors relative ${
                        active
                          ? 'text-orange-600 bg-orange-50 font-semibold'
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                      }`}
                    >
                      <Icon size={16} className="flex-shrink-0" />
                      <span>{item.label}</span>
                      {active && <div className="absolute right-4 w-1.5 h-1.5 rounded-full bg-orange-500"></div>}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
}